// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1uRBr","colCheckbox":"styles_colCheckbox__1uJrB"};